export type TValidation = {
  isValid: boolean;
  message: string;
};

export const initValidation: TValidation = {
  isValid: true,
  message: '',
};
